/* global $:true */
import plugin from '../../lib/plugin';
import { onAvailable } from "../../lib/selectors";

const ELEMENT_SELECTOR = '[data-exclusive-collapsible]';
const PLUGIN_NAME = 'exclusiveCollapsible';

export function exec() {
	onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		System.import(
			/* webpackChunkName: "plugin--exclusive-collapsible" */ "./exclusive-collapsible"
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/exclusive-collapsible/index.js